import { render, staticRenderFns } from "./ReportTaskList.vue?vue&type=template&id=70868f46&scoped=true&"
import script from "./ReportTaskList.vue?vue&type=script&lang=js&"
export * from "./ReportTaskList.vue?vue&type=script&lang=js&"
import style0 from "./ReportTaskList.vue?vue&type=style&index=0&id=70868f46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70868f46",
  null
  
)

export default component.exports